import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { RoleDto } from '../../../../api';
import { queryKeys } from '../../../../constants';
import useAuthenticatedClients from '../../../../hooks/useAuthenticatedClients';
import { onMutationError } from '../../../../utils/Utils';

function RoleQueries() {
  const { ROLES_QUERY_KEY } = queryKeys;
  const { getRolesClient } = useAuthenticatedClients();
  const queryClient = useQueryClient();

  const { mutate: mutateCreateRole } = useMutation<RoleDto, Error, RoleDto>(createRole, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(ROLES_QUERY_KEY);
      toast.success('Successfully created a new role');
    },
    onError: onMutationError,
  });

  const { mutate: mutateDeleteRole } = useMutation<void, Error, number>(deleteRole, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(ROLES_QUERY_KEY);
      toast.success('Successfully deleted role');
    },
    onError: onMutationError,
  });

  async function createRole(roleDto: RoleDto) {
    const client = await getRolesClient();
    const project = await client.createRole(roleDto);
    return project;
  }

  async function deleteRole(id: number) {
    const client = await getRolesClient();
    await client.deleteRole(id);
  }

  return {
    mutateCreateRole,
    mutateDeleteRole,
  };
}

export default RoleQueries;
